
import React from "react";

interface TrustIndicatorsProps {
  isAuthenticated: boolean;
  hasUsedDemo: boolean;
}

const TrustIndicators = ({ isAuthenticated, hasUsedDemo }: TrustIndicatorsProps) => {
  return (
    <div className="mt-6 text-center">
      <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground">
        <span>✓ {!isAuthenticated && !hasUsedDemo ? 'Free demo' : 'Free to use'}</span>
        <span>✓ AI-powered</span>
        <span>✓ Professional</span>
      </div>
    </div>
  );
};

export default TrustIndicators;
